var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback } from 'shared/components/features/ErrorFallback';
import { getSchedulingS3ConfigUrlFromHost, SCHEDULING_CONFIGS } from 'src/config';
import { useS3Config } from 'src/shared/hooks/useS3Config';
import ModuleLoader from 'src/shared/utils/ModuleLoader';
var SettingsSchedule = function (props) {
    var _a = useS3Config(getSchedulingS3ConfigUrlFromHost()), isFetched = _a.isFetched, config = _a.data;
    return (_jsx(ErrorBoundary, __assign({ FallbackComponent: ErrorFallback }, { children: isFetched && (config === null || config === void 0 ? void 0 : config.remoteEntry) && (_jsx(ModuleLoader, { url: config.remoteEntry, scope: "scheduling", module: "./Schedule", props: { config: SCHEDULING_CONFIGS } })) })));
};
export default SettingsSchedule;
